export default __webpack_public_path__ + "static/media/fa.bundle.8e769290.svg";